export default "__VITE_ASSET__LJ1Hwf1$__"